<template>
	<div>
		<router-view></router-view>
		<div class="menuTabbar" v-show="!(selected=='customerSer'&&isAndriod)">
			<router-link :to=item.urlData  v-for="(item,index) in itemData" :id="item.id" :key="item.id">
			<div class="itemTab" @click="changeSelected(item.id)" >
					<div class="tabIcon"><img :src="selected==item.id?item.imgHighSrc:item.imgSrc" /></div>
					<span class="txtColor" :class="selected==item.id?'txtColor_cur':'txtColor'">{{item.itemName}}</span>
			</div>
			</router-link>
		</div>
	</div>
	
</template>
<script>
	export default{
		data(){
			return {
				selected:'home',
				itemData:[
					{id:"home",itemName:"首页",imgSrc:require("../../assets/images/home.png"),imgHighSrc:require("../../assets/images/home_highlight.png"),urlData:'/index/'},
					{id:"topu",itemName:"拓扑",imgSrc:require("../../assets/images/topu.png"), imgHighSrc:require("../../assets/images/topu_hightlight.png"),urlData:'/index/topu'},
					{id:"worksheet",itemName:"工单",imgSrc:require("../../assets/images/worksheet.png"),imgHighSrc:require("../../assets/images/worksheet_light.png"),urlData:'/index/worksheet'},
					{id:"report",itemName:"报告",imgSrc:require("../../assets/images/report.png"),imgHighSrc:require("../../assets/images/report_light.png"),urlData:'/index/report'},
					{id:"customerSer",itemName:"客服",imgSrc:require("../../assets/images/customerService.png"),imgHighSrc:require("../../assets/images/customerService_highlight.png"),urlData:'/index/customerSer'},
					{id:"mine",itemName:"我的",imgSrc:require("../../assets/images/mine.png"),imgHighSrc:require("../../assets/images/mine_highlight.png"),urlData:'/index/mine'}
				],
			}
		},
		methods:{
			changeSelected(id){
				this.selected=id;
			},
			getParamsId(){
				var selectedId = this.$route.name;
				this.selected = selectedId;
			},
			hideRow(){
				for(let i=0;i<this.itemData.length;i++){
					if(this.itemData[i].id=="report"){
						this.itemData.splice(i,1);
					}
				}
			}
		},
		mounted:function(){
			this.getParamsId();
			if(window.location.protocol=='https:'){
				this.hideRow();
			}
		},
		computed:{
			isAndriod(){
				let u=navigator.userAgent;
				return u.indexOf('Android')>-1||u.indexOf("Linux")>-1
			}
		},
		watch:{
			'$route': function (to,from) {
			  if (to.path == '/index/home'||to.path == '/index'||to.path == '/index/') {
				  this.selected = 'home';
			  }
			  if (to.path == '/index/topu') {
			  	this.selected = 'topu';
			  }
			  if (to.path == '/index/worksheet') {
			  	this.selected = 'worksheet';
			  }
			  if (to.path == '/index/report') {
			  	this.selected = 'report';
			  }
			  if (to.path == '/index/customerSer') {
			  	this.selected = 'customerSer';
			  }
			  if (to.path == '/index/mine') {
			  	this.selected = 'mine';
			  }
			}
		}
	}
</script>
<style scoped="scoped">
	body{
		background: #F3F3F3;
	}
	.menuTabbar{
		width: 100%;
		height: 51px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: fixed;
		bottom: 0;
		background: #FFFFFF;
		box-shadow: 2px 2px 10px #CECECE;
	}
	.menuTabbar>a{
		width: 20%;
	}
	.itemTab{
		text-align: center;
	}
	.tabIcon{
		width: 18px;
		height: 18px;
		margin: 0 auto;
		margin-bottom: 3px;
	}
	.tabIcon>img{
		width: 100%;
		height: 100%;
	}
	.txtColor{
		color: #616161;
		font-size: 12px;
	}
	.txtColor_cur{
		color: #10AEFF;
	}
</style>


// WEBPACK FOOTER //
// src/views/index/FrameIndex.vue